// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mSchoolEventDetailsFormWidth{max-width:900px}`, "",{"version":3,"sources":["webpack://./src/views/GenericView/StudentView/Events/SummaryTabs/SummaryTabs.scss"],"names":[],"mappings":"AAAA,8BACE,eAAA","sourcesContent":[".mSchoolEventDetailsFormWidth {\n  max-width: 900px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
